export const DEFAULT_HEADER_HEIGHT = 64;
